import React from "react";
import CurrentStepShow from "components/CurrentStepShow";

export default function ProgressBar({ currentStep, setCurrentStep, stepLength }) {
   const steps = [];
   for (let i = 1; i <= stepLength; i++) {
      steps.push(<CurrentStepShow key={i} currentStep={currentStep} setCurrentStep={setCurrentStep} number={i} />);
   }

   return (
      <section>
         <div className="bg-home-form h-350 align-items-end pb-50 bg-blue">
            <div className="container">
               <div className="row">
                  <div id="top" className="col-md-8">
                     <p className="subtitle">RAPID SI SIGUR</p>
                     <h1 className="font-size-52">Contractare online</h1>
                  </div>
               </div>
               <div className="row">
                  <div className="col-md-12 div-pasi">{steps}</div>
               </div>
            </div>
         </div>
      </section>
   );
}
